import i18n from '@signavio/i18n';
import { StringUtils } from '@signavio/effektif-commons';
export default function emailAddress({
  value
}) {
  if (!value) {
    return [];
  }
  const i = value.indexOf('<');
  const j = value.indexOf('>');
  const email = i && j && j > i ? value.substring(i + 1, j) : value;
  if (!StringUtils.validateEmail(email)) {
    return [i18n('Please enter a valid email address.')];
  }
  return [];
}